import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { SettingsProvider } from '@services/settings/settings';
import { takeUntil } from 'rxjs/operators';
import { CustomizedLabels } from '@models/models';

@Component({
	selector: 'quote-from-info',
	template: require('./quote-from-info.html'),
	styles: [require('./quote-from-info.scss')]
})
export class QuoteFromInfoComponent {
	@Input('company') company;
	businessNumberLabelName: string;

	private unsubscribe: Subject<void> = new Subject<void>();

	constructor(private settingsService: SettingsProvider) {}

	ngOnInit(): void {
		this.subscribeToCustomizeLabelsChange();
	}

	ngOnDestroy() {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	private subscribeToCustomizeLabelsChange(): void {
		this.settingsService.customizeLabelsObservable
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(
				(customizeLabels: CustomizedLabels): string =>
					(this.businessNumberLabelName = customizeLabels.businessNumberLabel)
			);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=xqsfzqb50j!./web/modern/components/quote/common/quote-from-info/quote-from-info.ts